// Knappen "Hantera kakor" i sidfoten öppnar Cookiebots banner direkt i detaljläget.
// Motsvarar attachShowCookieBannerDetailsEvent i Frontend/src/scripts/2-functions/_cookieBot.ts,
// men ligger här så att huvudwebbens skript inte delas upp eller dras in i kampanjens bundle.

let openDetails = false;

export function initCookieBannerLinks(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    ".js-show-cookie-banner-details",
  );

  if (buttons.length === 0) {
    return;
  }

  buttons.forEach((btn) =>
    btn.addEventListener("click", () => {
      if (window.Cookiebot) {
        openDetails = true;
        window.Cookiebot.show();
      }
    }),
  );

  window.addEventListener("CookiebotOnDialogDisplay", () => {
    // Gör bara något när det var vår knapp som öppnade bannern.
    if (!openDetails) return;

    const cookieBanner = document.getElementById("CookieBanner");
    const detailsToggle = document.querySelector<HTMLButtonElement>(
      ".cookiebanner__details-toggle",
    );

    if (!cookieBanner || !detailsToggle) return;

    detailsToggle.addEventListener("click", (event) => {
      if (!cookieBanner.classList.contains("is-details-open")) return;

      // Stänger detaljerna: har besökaren redan svarat stängs hela bannern i stället.
      if (window.Cookiebot?.consented || window.Cookiebot?.declined) {
        event.stopImmediatePropagation();
        window.Cookiebot.hide();
      }
    });

    cookieBanner.classList.add("is-details-open");
    detailsToggle.setAttribute("aria-expanded", "true");
    detailsToggle.textContent =
      detailsToggle.getAttribute("data-details-close");
    cookieBanner.style.overflowY = "scroll";
    openDetails = false;
  });
}
